import { render, staticRenderFns } from "./addMerchant.vue?vue&type=template&id=e1455d7a&scoped=true&"
import script from "./addMerchant.vue?vue&type=script&lang=js&"
export * from "./addMerchant.vue?vue&type=script&lang=js&"
import style0 from "./addMerchant.vue?vue&type=style&index=0&id=e1455d7a&scoped=true&lang=css&"
import style1 from "./addMerchant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1455d7a",
  null
  
)

export default component.exports